import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=77550de0&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=ts&"
export * from "./Register.vue?vue&type=script&lang=ts&"
import style0 from "./Register.vue?vue&type=style&index=0&id=77550de0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77550de0",
  null
  
)

export default component.exports